import { render, staticRenderFns } from "./SAccUsers.vue?vue&type=template&id=5b7c24a7&scoped=true"
import script from "./SAccUsers.vue?vue&type=script&lang=ts"
export * from "./SAccUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c24a7",
  null
  
)

export default component.exports